import { useQuery } from '@tanstack/react-query';

import { useCategoryTreeItem } from '../categoryTree';
import { queryKeys } from '../queryKeys';

import { createChannelCollectionQueryOptions } from './queryOptions';

export function useChannelCollection({ referenceId }: { referenceId: string }) {
  const category = useCategoryTreeItem(referenceId);
  const isEnabled = Boolean(category);

  const { data, isLoading, error } = useQuery({
    ...createChannelCollectionQueryOptions({ referenceId }),
    enabled: isEnabled,
    queryKey: isEnabled ? queryKeys.channelCollection(referenceId) : queryKeys.disabled,
  });

  return {
    channelCollection: data?.collection,
    isLoading,
    error,
  };
}
